// @flow
import { useMutation } from 'react-apollo';

import { USER_ACCOUNT_INFO_UPDATE_MUTATION } from 'graphql/mutations';
import { USER_ACCOUNT_INFO_QUERY } from 'graphql/queries';
import type { UserAccountInfoResponse } from './index';


const getUserAccountInfoData = (data: any) => {
  // $FlowIgnore
  const userAccountInfo: UserAccountInfoResponse = (data && data.system && data.system.memberAccountUpsert) || {};

  return userAccountInfo;
};

export const useUserAccountInfoUpdate = (graphqlOptions: Object = {}) => {
  return useMutation(USER_ACCOUNT_INFO_UPDATE_MUTATION, {
    awaitRefetchQueries: true,
    refetchQueries: [{
      query: USER_ACCOUNT_INFO_QUERY,
    }],
    ...graphqlOptions,
    onCompleted: (data) => {
      graphqlOptions.onCompleted && graphqlOptions.onCompleted(getUserAccountInfoData(data));
    },
  });
};
